"use client";

// ============================================================
// ANSICHTSSACHE-AGENT – Aufgeschlagene Zeile in den Blick
// ============================================================
// Ein Verweis auf EINE Zeile einer Liste landet auf dieser Zeile
// und nicht oben in der Liste. Wer aus der Personalakte „Rolle
// und Zugang ändern“ waehlt, steht unter Team › Benutzer auf
// SEINER Zeile (`?person=<id>`); wer in der Zeiterfassung „Im
// Projekt zeigen“ waehlt, auf seiner Buchung im Register Zeit des
// Projekts (`?buchung=<id>`).
//
// Warum kein Anker (`#benutzer-…`) mit `:target`: der App Router
// wechselt die Seite per `pushState`, und dabei setzt der Browser
// `:target` nicht — die Zeile waere nie hervorgehoben. Die
// Hervorhebung kommt deshalb vom Server, das Rollen von hier.
//
// Gerollt wird im Effekt, also NACH dem Rollen des Routers an den
// Anfang des neuen Abschnitts — sonst naehme er es gleich wieder
// zurueck.
//
// Und zwar NUR die Flaeche, in der die Zeile steht (die Karte der
// Einstellungen rollt innen). `scrollIntoView` bewegt jede Flaeche
// darueber mit, auch das Dokument: auf einem niedrigen Fenster
// rutschte dabei die ganze Seite samt Kopf und Seitenleiste nach
// oben (nachgemessen bei 560 Pixel Hoehe, 24.09.2026).
//
// Rollt KEINE Flaeche darueber, rollt die Seite selbst — so im
// Register Zeit eines Projekts, wo Kennzahlen und Verlauf ueber der
// Liste stehen und das Dokument laenger ist als das Fenster.
// ============================================================

import { useEffect } from "react";

export function ScrollIntoView({ targetId }: { targetId: string }) {
  useEffect(() => {
    const target = document.getElementById(targetId);
    if (!target) return;

    const row = target.getBoundingClientRect();
    const area = scrollArea(target);
    if (area) {
      const frame = area.getBoundingClientRect();
      area.scrollTop += row.top - frame.top - (frame.height - row.height) / 2;
    } else {
      window.scrollBy({ top: row.top - (window.innerHeight - row.height) / 2 });
    }
  }, [targetId]);

  return null;
}

/** Die naechste Flaeche ueber dem Element, die wirklich rollt. */
function scrollArea(element: HTMLElement): HTMLElement | null {
  for (let parent = element.parentElement; parent; parent = parent.parentElement) {
    const { overflowY } = getComputedStyle(parent);
    const rolls = overflowY === "auto" || overflowY === "scroll";
    if (rolls && parent.scrollHeight > parent.clientHeight) return parent;
  }
  return null;
}
